// THIS IS AN AUTO GENERATED FILE, ANY MANUAL CHANGES MIGHT BE OVERRIDDEN
import { Injectable } from "@angular/core";
@Injectable({
  providedIn: "root",
})
export class ComponentExporterService {
  constructor() {}

  public resolveComponent(componentName: string) {
    switch (componentName) {
      case "AccountApplicationDecisioningDashboardComponent":
        return import(
          "../account-application-decisioning/account-application-decisioning-dashboard/account-application-decisioning-dashboard.component"
        );

      case "AccountApplicationDecisioningSummaryComponent":
        return import(
          "../account-application-decisioning/account-application-decisioning-summary/account-application-decisioning-summary.component"
        );

      case "AccountApplicationDecisioningDetailsComponent":
        return import(
          "../account-application-decisioning/account-application-decisioning-details/account-application-decisioning-details.component"
        );

      case "ApplicationConfigurationAddEditComponent":
        return import(
          "../account-application/application-configuration-add-edit/application-configuration-add-edit.component"
        );

      case "ApplicationConfigurationListComponent":
        return import(
          "../account-application/application-configuration-list/application-configuration-list.component"
        );

      case "HomeComponent":
        return import("../admin/home/home/home.component");

      case "MenuGroupCreateComponent":
        return import(
          "../admin/menu/menu-group-create/menu-group-create.component"
        );

      case "MenuGroupListComponent":
        return import(
          "../admin/menu/menu-group-list/menu-group-list.component"
        );

      case "NotificationTopicListComponent":
        return import(
          "../admin/notification/notification-topic-list/notification-topic-list.component"
        );

      case "NotificationTopicCreateComponent":
        return import(
          "../admin/notification/notification-topic-create/notification-topic-create.component"
        );

      case "PermissionListComponent":
        return import(
          "../admin/permission/permission-list/permission-list.component"
        );

      case "PermissionCreateComponent":
        return import(
          "../admin/permission/permission-create/permission-create.component"
        );

      case "ProfileComponent":
        return import("../admin/profile/profile.component");

      case "RoleListComponent":
        return import("../admin/role/role-list/role-list.component");

      case "RoleCreateComponent":
        return import("../admin/role/role-create/role-create.component");

      case "TitleListComponent":
        return import("../admin/title/title-list/title-list.component");

      case "UserListComponent":
        return import("../admin/user/user-list/user-list.component");

      case "UserCreateComponent":
        return import("../admin/user/user-create/user-create.component");

      case "UserGroupListComponent":
        return import(
          "../admin/user-group/user-group-list/user-group-list.component"
        );

      case "UserGroupCreateComponent":
        return import(
          "../admin/user-group/user-group-create/user-group-create.component"
        );

      case "PageNotFoundComponent":
        return import("../admin/page-not-found/page-not-found.component");

      case "BranchListComponent":
        return import("../admin/branch/branch-list/branch-list.component");

      case "BranchCreateComponent":
        return import("../admin/branch/branch-create/branch-create.component");

      case "ItDashboardComponent":
        return import(
          "../admin/it-dashboard/it-dashboard/it-dashboard.component"
        );

      case "MailchimpCampaignCreateComponent":
        return import(
          "../admin/mailchimp-campaign/mailchimp-campaign-create/mailchimp-campaign-create.component"
        );

      case "MailchimpCampaignListComponent":
        return import(
          "../admin/mailchimp-campaign/mailchimp-campaign-list/mailchimp-campaign-list.component"
        );

      case "TodoTemplateListComponent":
        return import(
          "../admin/todo-template/todo-template-list/todo-template-list.component"
        );

      case "TodoTemplateComponent":
        return import(
          "../admin/todo-template/todo-template/todo-template.component"
        );

      case "EmailHistoryComponent":
        return import(
          "../admin/email-history/email-history/email-history.component"
        );

      case "UserConsolidationComponent":
        return import(
          "../admin/user-consolidation/user-consolidation/user-consolidation.component"
        );

      case "MergeUserComponent":
        return import(
          "../admin/user-consolidation/merge-user/merge-user.component"
        );

      case "LogListComponent":
        return import("../logging/components/log-list/log-list.component");

      case "ActivityCodeListComponent":
        return import(
          "../admin/activity-code/activity-code-list/activity-code-list.component"
        );

      case "LoanPipelineTestComponent":
        return import(
          "../loan-pipeline-test/loan-pipeline-test/loan-pipeline-test.component"
        );

      case "LegalDisclosureListComponent":
        return import(
          "../admin/legal-disclosure/components/legal-disclosure-list/legal-disclosure-list.component"
        );

      case "LegalDisclosureDetailComponent":
        return import(
          "../admin/legal-disclosure/components/legal-disclosure-detail/legal-disclosure-detail.component"
        );

      case "QuickSightDashboardPromotionComponent":
        return import(
          "../admin/quick-sight-dashboard-promotion/quick-sight-dashboard-promotion/quick-sight-dashboard-promotion.component"
        );

      case "AppointmentSchedulerComponent":
        return import(
          "../training/appointment-scheduler/appointment-scheduler/appointment-scheduler.component"
        );

      case "SuggestionBoxComponent":
        return import("../training/suggestion-box/suggestion-box.component");

      case "TravelRequestComponent":
        return import(
          "../training/travel-request/travel-request/travel-request.component"
        );

      case "CampaignManagementDashboardComponent":
        return import(
          "../campaign-management/campaign-management-dashboard/campaign-management-dashboard.component"
        );

      case "CampaignDetailsModalComponent":
        return import(
          "../campaign-management/campaign-details-modal/campaign-details-modal.component"
        );

      case "CommercialLenderApplicationListComponent":
        return import(
          "../commercial-lender-application/components/commercial-lender-application-list/commercial-lender-application-list.component"
        );

      case "CommercialLenderApplicationAddOrEditComponent":
        return import(
          "../commercial-lender-application/components/commercial-lender-application-add-or-edit/commercial-lender-application-add-or-edit.component"
        );

      case "ProjectTrackerConfigurationComponent":
        return import(
          "../configurations/components/project-tracker-configuration/project-tracker-configuration.component"
        );

      case "CRMDashboardComponent":
        return import("../crm-dashboard/crm-dashboard.component");

      case "DeveloperPanelFileDownloaderComponent":
        return import(
          "../developer-panel/components/developer-panel-file-downloader/developer-panel-file-downloader.component"
        );

      case "DeveloperPanelFileUploaderComponent":
        return import(
          "../developer-panel/components/developer-panel-file-uploader/developer-panel-file-uploader.component"
        );

	  case "DeveloperPanelChatBotComponent":
        return import(
          "../developer-panel/components/developer-panel-chat-bot/developer-panel-chat-bot/developer-panel-chat-bot.component"
        );

      case "DeveloperPanelFileDeleteComponent":
        return import(
          "../developer-panel/components/developer-panel-file-delete/developer-panel-file-delete.component"
        );

      case "DeveloperPanelHomeComponent":
        return import(
          "../developer-panel/components/developer-panel-home/developer-panel-home.component"
        );

      case "DisclosureAddEditComponent":
        return import(
          "../disclosure/disclosure-add-edit/disclosure-add-edit.component"
        );

      case "DisclosureListComponent":
        return import(
          "../disclosure/disclosure-list/disclosure-list.component"
        );

      case "EmployeeDirectoryComponent":
        return import(
          "../employee-directory/employee-directory/employee-directory.component"
        );

      case "EmployeeProfileComponent":
        return import(
          "../employee-directory/employee-profile/employee-profile.component"
        );

      case "EmployeeListComponent":
        return import(
          "../employee-directory/employee-list/employee-list.component"
        );

      case "EmployeePhotosComponent":
        return import(
          "../employee-photos/components/employee-photos/employee-photos.component"
        );

      case "ViewFeedbackComponent":
        return import(
          "../feedback/components/view-feedback/view-feedback.component"
        );

      case "GsConnectComponent":
        return import(
          "../gs-connect/components/gs-connect/gs-connect.component"
        );

      case "GsConnectListItemComponent":
        return import(
          "../gs-connect/components/gs-connect-list-item/gs-connect-list-item.component"
        );

      case "GsConnectEventListComponent":
        return import(
          "../gs-connect/shared/gs-connect-event-list/gs-connect-event-list.component"
        );

      case "GsCelebrationImageHubComponent":
        return import(
          "../gs-celebration-image-hub/components/gs-celebration-image-hub/gs-celebration-image-hub.component"
        );

      case "PostReactionsComponent":
        return import(
          "../gs-connect/shared/post-reactions/post-reactions.component"
        );

      case "JobStatusDashboardComponent":
        return import(
          "../admin/gs-job/gs-job-status-dashboard/gs-job-status-dashboard.component"
        );

      case "GsJobListComponent":
        return import("../admin/gs-job/gs-job-list/gs-job-list.component");

      case "GsJobHistoryComponent":
        return import(
          "../admin/gs-job/gs-job-history/gs-job-history.component"
        );

      case "GsJobCreateComponent":
        return import("../admin/gs-job/gs-job-create/gs-job-create.component");

      case "GsJobContentComponent":
        return import(
          "../admin/gs-job/gs-job-content/gs-job-content.component"
        );

      case "GsJobCreateModalComponent":
        return import(
          "../admin/gs-job/gs-job-create-modal/gs-job-create-modal.component"
        );

      case "GsJobTypeCreateComponent":
        return import(
          "../admin/gs-job/gs-job-type-create/gs-job-type-create.component"
        );

      case "GsJobNotificationTemplateCreateComponent":
        return import(
          "../admin/gs-job/gs-job-notification/gs-job-notification-template-create/gs-job-notification-template-create.component"
        );

      case "GsJobNotificationTemplateDashboardComponent":
        return import(
          "../admin/gs-job/gs-job-notification/gs-job-notification-template-dashboard/gs-job-notification-template-dashboard.component"
        );

      case "JobNotificationsComponent":
        return import(
          "../admin/gs-job/gs-job-notification/gs-job-notification/gs-job-notification.component"
        );

      case "JobCategoryComponent":
        return import(
          "../admin/gs-job/job-category-drill-down/job-category-drill-down.component"
        );

      case "HrManagerAllowanceAuditComponent":
        return import(
          "../gs-rewards/components/hr-manager-allowance-audit/hr-manager-allowance-audit.component"
        );

      case "HrRewardsMaintenanceComponent":
        return import(
          "../gs-rewards/components/hr-rewards-maintenance/hr-rewards-maintenance.component"
        );

      case "HrWalletAdminComponent":
        return import(
          "../gs-rewards/components/hr-wallet-admin/hr-wallet-admin.component"
        );

      case "MyRewardsComponent":
        return import(
          "../gs-rewards/components/my-rewards/my-rewards.component"
        );

      case "HtmlTemplateAddOrEditComponent":
        return import(
          "../html-template/html-template-add-or-edit/html-template-add-or-edit.component"
        );

      case "HtmlTemplateListComponent":
        return import(
          "../html-template/html-template-list/html-template-list.component"
        );

      case "LoanMaturingDashboard":
        return import(
          "../loan-maturing/components/loan-maturing-dashboard/loan-maturing-dashboard.component"
        );

      case "LoanMaturityComponent":
        return import(
          "../loan-maturing/components/loan-maturing/loan-maturing.component"
        );

      case "LookupComponent":
        return import(
          "../admin/lookup-table/components/lookup/lookup.component"
        );

      case "LookupTableContentComponent":
        return import(
          "../admin/lookup-table/components/lookup-table-content/lookup-table-content.component"
        );

      case "ManageAppointmentComponent":
        return import(
          "../manage-appointment/manage-appointment/manage-appointment.component"
        );

      case "ManagerUpdateToolComponent":
        return import(
          "../manager-update-tool/components/manager-update-tool/manager-update-tool.component"
        );

      case "ManagerUpdateDialogComponent":
        return import(
          "../manager-update-tool/components/manager-update-dialog/manager-update-dialog.component"
        );

      case "MarketingAssetComponent":
        return import(
          "../marketing-assets/marketing-asset/marketing-asset.component"
        );

      case "PersonalBrandingAssetsComponent":
        return import(
          "../personal-branding-assets/personal-branding-assets/personal-branding-assets.component"
        );

      case "ConnectedUserListComponent":
        return import(
          "../notifications/connected-user-list/connected-user-list.component"
        );

      case "NotificationDetailComponent":
        return import(
          "../notifications/notification-detail/notification-detail.component"
        );

      case "NotificationDetailListComponent":
        return import(
          "../notifications/notification-detail-list/notification-detail-list.component"
        );

      case "NotificationTesterComponent":
        return import(
          "../notifications/notification-tester/notification-tester.component"
        );

      case "OverdraftNoticeTemplateManagementComponent":
        return import(
          "../overdraft-program/components/overdraft-notice-template-management/overdraft-notice-template-management.component"
        );

      case "OverdraftProgramAccountDetailsComponent":
        return import(
          "../overdraft-program/components/overdraft-program-account-details/overdraft-program-account-details.component"
        );

      case "OverdraftProgramCallHistoryComponent":
        return import(
          "../overdraft-program/components/overdraft-program-call-history/overdraft-program-call-history.component"
        );

      case "OverdraftProgramDashboardComponent":
        return import(
          "../overdraft-program/components/overdraft-program-dashboard/overdraft-program-dashboard.component"
        );

      case "OverdraftProgramLetterNoticeHistoryComponent":
        return import(
          "../overdraft-program/components/overdraft-program-letter-notice-history/overdraft-program-letter-notice-history.component"
        );

      case "OverdraftProgramLimitHistoryComponent":
        return import(
          "../overdraft-program/components/overdraft-program-limit-history/overdraft-program-limit-history.component"
        );

      case "OverdraftProgramPortalComponent":
        return import(
          "../overdraft-program/components/overdraft-program-portal/overdraft-program-portal.component"
        );

      case "OverdraftProgramRegeHistoryComponent":
        return import(
          "../overdraft-program/components/overdraft-program-rege-history/overdraft-program-rege-history.component"
        );

      case "OverdraftRulesComponent":
        return import(
          "../overdraft-program/components/overdraft-rules/overdraft-rules.component"
        );

      case "OverdraftProgramReportsComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-program-reports/overdraft-program-reports.component"
        );

      case "AccountPerformanceSummaryDDAComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/performance-summary-dda/performance-summary-dda.component"
        );

      case "AccountNetDDAGrowthComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/net-dda-growth/net-dda-growth.component"
        );

      case "AccountCommittedODAndPercentLimitComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/committed-od-and-percent-limit/committed-od-and-percent-limit.component"
        );

      case "AccountDDActiveODAccountStatusComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/dda-active-od-account-status/dda-active-od-account-status.component"
        );

      case "AccountNSFItemsComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/nsf-items/nsf-items.component"
        );

      case "FeeStatisticsComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/fee-statistics/fee-statistics.component"
        );

      case "AccountStatisticsComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/account-statistics/account-statistics.component"
        );

      case "AccountDDADepositActivityComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/dda-deposit-activity/dda-deposit-activity.component"
        );

      case "AccountRegEAccountStatusComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/reg-e-account-status/reg-e-account-status.component"
        );

      case "DdaPayRatioComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/dda-pay-ratio/dda-pay-ratio.component"
        );

      case "DdaNsfActivityComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/dda-nsf-activity/dda-nsf-activity.component"
        );

      case "OverdraftReportsSidebarComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-sidebar/overdraft-reports-sidebar.component"
        );

      case "WaivedFeeComponent":
        return import(
          "../overdraft-program/components/overdraft-reports/overdraft-reports-graphs/waived-fee/waived-fee.component"
        );

      case "AnnualGoalsGridComponent":
        return import(
          "../private-banking/components/domestic-private-banking/components/annual-goals-grid/annual-goals-grid.component"
        );

      case "GoalsComponent":
        return import(
          "../private-banking/components/domestic-private-banking/components/goals/goals.component"
        );

      case "ManageGoalsComponent":
        return import(
          "../private-banking/components/domestic-private-banking/components/manage-goals/manage-goals.component"
        );

      case "MonthlyGoalsGridComponent":
        return import(
          "../private-banking/components/domestic-private-banking/components/monthly-goals-grid/monthly-goals-grid.component"
        );

      case "DomesticPrivateBankingManagementComponent":
        return import(
          "../private-banking/components/domestic-private-banking/components/domestic-private-banking-management/domestic-private-banking-management.component"
        );

      case "QuarterlyGoalsGridComponent":
        return import(
          "../private-banking/components/domestic-private-banking/components/quarterly-goals-grid/quarterly-goals-grid.component"
        );

      case "InternationalPrivateBankingManagementComponent":
        return import(
          "../private-banking/components/international-private-banking/international-private-banking-management/international-private-banking-management.component"
        );

      case "RelationshipDetailsComponent":
        return import(
          "../private-banking/components/relationship-details/relationship-details.component"
        );

      case "ViewTeamMembersComponent":
        return import(
          "../private-banking/components/view-team-members/view-team-members.component"
        );

      case "ProfitCenterGlMappingDashboardComponent":
        return import(
          "../profit-center-gl-mapping/components/profit-center-gl-mapping-dashboard/profit-center-gl-mapping-dashboard.component"
        );

      case "ProfitCenterGlMappingMaintenanceComponent":
        return import(
          "../profit-center-gl-mapping/components/profit-center-gl-mapping-maintenance/profit-center-gl-mapping-maintenance.component"
        );

      case "ProjectTrackerDashboardComponent":
        return import(
          "../project-tracker/components/project-tracker-dashboard/project-tracker-dashboard.component"
        );

      case "ProjectTrackerAddComponent":
        return import(
          "../project-tracker/components/project-tracker-add/project-tracker-add.component"
        );

      case "ProjectTrackerEditComponent":
        return import(
          "../project-tracker/components/project-tracker-edit/project-tracker-edit.component"
        );

      case "GenerateQRCodeComponent":
        return import("../qr-code/generate-qr-code/generate-qr-code.component");

      case "QuickSightReportViewerComponent":
        return import(
          "../quick-sight-reports/components/report-viewer/quick-sight-report-viewer.component"
        );

      case "ReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/referral-dashboard/referral-dashboard.component"
        );

      case "FxReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/fx-referral-dashboard/fx-referral-dashboard.component"
        );

      case "InsuranceReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/insurance-referral-dashboard/insurance-referral-dashboard.component"
        );

      case "TreasuryReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/treasury-referral-dashboard/treasury-referral-dashboard.component"
        );

      case "MerchantReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/merchant-referral-dashboard/merchant-referral-dashboard.component"
        );

      case "MortgageReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/mortgage-referral-dashboard/mortgage-referral-dashboard.component"
        );

      case "WealthReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/wealth-referral-dashboard/wealth-referral-dashboard.component"
        );

      case "FxEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/fx-edit/fx-edit.component"
        );

      case "InsuranceEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/insurance-edit/insurance-edit.component"
        );

      case "MerchantEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/merchant-edit/merchant-edit.component"
        );

      case "MortgageEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/mortgage-edit/mortgage-edit.component"
        );

      case "TreasuryEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/treasury-edit/treasury-edit.component"
        );

      case "WealthEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/wealth-edit/wealth-edit.component"
        );

      case "FxReferralComponent":
        return import("../referral/fx-referral/fx-referral.component");

      case "InsuranceReferralComponent":
        return import(
          "../referral/insurance-referral/insurance-referral.component"
        );

      case "MerchantComponent":
        return import("../referral/merchant/merchant.component");

      case "MortgageComponent":
        return import("../referral/mortgage/mortgage.component");

      case "TreasuryComponent":
        return import("../referral/treasury/treasury.component");

      case "WealthComponent":
        return import("../referral/wealth/wealth.component");

      case "ViewUserReferralComponent":
        return import(
          "../referral/view-user-referral/view-user-referral.component"
        );

      case "EmployeeReferralComponent":
        return import(
          "../referral/employee-referral/employee-referral.component"
        );

      case "EmployeeEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/employee-edit/employee-edit.component"
        );

      case "EmployeeReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/employee-referral-dashboard/employee-referral-dashboard.component"
        );

      case "ConfigureIncentiveDashboardComponent":
        return import(
          "../referral/referral-dashboard/configure-incentive-dashboard/configure-incentive-dashboard.component"
        );

      case "InternationalPrivateClientReferralComponent":
        return import(
          "../referral/international-private-client-referral/international-private-client-referral.component"
        );

      case "CreditCardReferralComponent":
        return import(
          "../referral/credit-card-referral/credit-card-referral.component"
        );

      case "CreditCardReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/credit-card-referral-dashboard/credit-card-referral-dashboard.component"
        );

      case "InternationalPrivateClientReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/international-private-client-referral-dashboard/international-private-client-referral-dashboard.component"
        );

      case "CreditCardEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/credit-card-edit/credit-card-edit.component"
        );

      case "InternationalPrivateClientEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/international-private-client-edit/international-private-client-edit.component"
        );

      case "ConsolidatedReportComponent":
        return import(
          "../referral/regional-reports/consolidated-report/consolidated-report.component"
        );

      case "DepositAccountReferralComponent":
        return import(
          "../referral/deposit-account-referral/deposit-account-referral.component"
        );

      case "DomesticPrivateClientReferralComponent":
        return import(
          "../referral/domestic-private-client-referral/domestic-private-client-referral.component"
        );

      case "DomesticPrivateClientReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/domestic-private-client-referral-dashboard/domestic-private-client-referral-dashboard.component"
        );

      case "DepositAccountReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/deposit-account-referral-dashboard/deposit-account-referral-dashboard.component"
        );

      case "DomesticPrivateClientEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/domestic-private-client-edit/domestic-private-client-edit.component"
        );

      case "DepositAccountEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/deposit-account-edit/deposit-account-edit.component"
        );

      case "LoanEditComponent":
        return import(
          "../referral/referral-dashboard/referral-edit/loan-edit/loan-edit.component"
        );

      case "LoanReferralDashboardComponent":
        return import(
          "../referral/referral-dashboard/loan-referral-dashboard/loan-referral-dashboard.component"
        );

      case "LoanReferralComponent":
        return import("../referral/loan-referral/loan-referral.component");

      case "RgvRegionalReportComponent":
        return import(
          "../referral/regional-reports/rgv-regional-report/rgv-regional-report.component"
        );

      case "DfwRegionalReportComponent":
        return import(
          "../referral/regional-reports/dfw-regional-report/dfw-regional-report.component"
        );

      case "HillCountryRegionalReportComponent":
        return import(
          "../referral/regional-reports/hill-country-regional-report/hill-country-regional-report.component"
        );

      case "HoustonRegionalReportComponent":
        return import(
          "../referral/regional-reports/houston-regional-report/houston-regional-report.component"
        );

      case "RelationshipAnalysisComponent":
        return import(
          "../relationship-analysis/components/relationship-analysis/relationship-analysis.component"
        );

      case "ViewMLOListingComponent":
        return import(
          "../reports/components/view-mlo-listing/view-mlo-listing.component"
        );

      case "MloUserBranchListingComponent":
        return import(
          "../reports/mlo-user-branch-listing/components/mlo-user-branch-listing/mlo-user-branch-listing.component"
        );

      case "ReportingAccountOpeningDashboardViewComponent":
        return import(
          "../reports/components/reporting-account-opening-dashboard-view/reporting-account-opening-dashboard-view.component"
        );

      case "ReportingAdminDashboardComponent":
        return import(
          "../reports/components/reporting-admin-dashboard/reporting-admin-dashboard.component"
        );

      case "ReportingAdminDashboardEditComponent":
        return import(
          "../reports/components/reporting-admin-dashboard-edit/reporting-admin-dashboard-edit.component"
        );

      case "ReportAdminComponent":
        return import(
          "../reports/components/report-admin/report-admin.component"
        );

      case "ReportAdminEditComponent":
        return import(
          "../reports/components/report-edit/report-edit.component"
        );

      case "ReportConfiguratorComponent":
        return import(
          "../reports/components/report-configurator/report-configurator.component"
        );

      case "ReportViewerComponent":
        return import(
          "../reports/components/report-viewer/report-viewer.component"
        );

      case "ReportingDashboardComponent":
        return import("../reporting-dashboard/reporting-dashboard.component");

      case "ReportingDashboardViewComponent":
        return import(
          "../reporting-dashboard-view/reporting-dashboard-view.component"
        );

      case "WikiManualComponent":
        return import(
          "../resource-center/components/wiki-manual/wiki.component"
        );

      case "WikiPageContentComponent":
        return import(
          "../resource-center/components/wiki-page-content/wiki-page-content.component"
        );

      case "SearchRecordComponent":
        return import(
          "../resource-center/components/wiki-page-content/search-record/search-record.component"
        );

      case "EditPageContentComponent":
        return import(
          "../resource-center/components/wiki-page-content/edit-page-content/edit-page-content.component"
        );

      case "AddEditPageContentComponent":
        return import(
          "../resource-center/components/wiki-page-content/add-edit-page-content/add-edit-page-content.component"
        );

      case "WikiRoleManagementComponent":
        return import(
          "../resource-center/components/wiki-page-content/wiki-role-management/wiki-role-management.component"
        );

      case "ServiceDeskDashboardComponent":
        return import(
          "../service-desk/service-desk-dashboard/service-desk-dashboard/service-desk-dashboard.component"
        );

      case "MarketingServiceTicketAddComponent":
        return import(
          "../service-desk/service-desk-add/marketing-service-ticket-add/marketing-service-ticket-add.component"
        );

      case "MarketingServiceTicketEditComponent":
        return import(
          "../service-desk/service-desk-dashboard/service-desk-edit/marketing-service-ticket-edit/marketing-service-ticket-edit.component"
        );

      case "FacilitiesServiceTicketAddComponent":
        return import(
          "../service-desk/service-desk-add/facilities-service-ticket-add/facilities-service-ticket-add.component"
        );

      case "FacilitiesServiceTicketEditComponent":
        return import(
          "../service-desk/service-desk-dashboard/service-desk-edit/facilities-service-ticket-edit/facilities-service-ticket-edit.component"
        );

      case "FacilitiesServiceTicketDashboardComponent":
        return import(
          "../service-desk/service-desk-dashboard/facilities-dashboard/facilities-dashboard.component"
        );

      case "ViewTicketsComponent":
        return import("../service-desk/view-tickets/view-tickets.component");

      case "MarketingServiceTicketDashboardComponent":
        return import(
          "../service-desk/service-desk-dashboard/marketing-dashboard/marketing-dashboard.component"
        );

      case "BranchAdminServiceTicketAddComponent":
        return import(
          "../service-desk/service-desk-add/branch-admin-service-ticket-add/branch-admin-service-ticket-add.component"
        );

      case "BranchAdminServiceTicketEditComponent":
        return import(
          "../service-desk/service-desk-dashboard/service-desk-edit/branch-admin-service-ticket-edit/branch-admin-service-ticket-edit.component"
        );

      case "BranchAdminServiceTicketDashboardComponent":
        return import(
          "../service-desk/service-desk-dashboard/branch-admin-dashboard/branch-admin-dashboard.component"
        );

      case "FacilitiesAddEditVendorComponent":
        return import(
          "../service-desk/vendor/add-edit-vendor/facilities-add-edit-vendor/facilities-add-edit-vendor.component"
        );

      case "FacilitiesVendorDashboardComponent":
        return import(
          "../service-desk/vendor/vendor-dashboard/facilities-vendor-dashboard/facilities-vendor-dashboard.component"
        );

      case "MarketingReportComponent":
        return import(
          "../service-desk/service-desk-dashboard/report/marketing-report/marketing-report.component"
        );

      case "BranchAdminReportComponent":
        return import(
          "../service-desk/service-desk-dashboard/report/branch-admin-report/branch-admin-report.component"
        );

      case "ServiceDeskConsolidatedReportComponent":
        return import(
          "../service-desk/service-desk-dashboard/report/consolidated-report/consolidated-report.component"
        );

      case "FacilitiesReportComponent":
        return import(
          "../service-desk/service-desk-dashboard/report/facilities-report/facilities-report.component"
        );

      case "ItSupportCategoryDashboardComponent":
        return import(
          "../service-desk/ticket-categories/it-support-ticket-categories/it-support-category-dashboard/it-support-category-dashboard.component"
        );

      case "ItSupportDashboardComponent":
        return import(
          "../service-desk/it-support/it-support-dashboard/it-support-dashboard.component"
        );

      case "ItSupportServiceTicketAddComponent":
        return import(
          "../service-desk/it-support/it-support-ticket-add/it-support-ticket-add.component"
        );

      case "ItSupportServiceTicketEditComponent":
        return import(
          "../service-desk/it-support/it-support-ticket-edit/it-support-ticket-edit.component"
        );

      case "CollateralServiceTicketAddComponent":
        return import(
          "../service-desk/collateral-management/collateral-service-ticket-add/collateral-service-ticket-add.component"
        );

      case "CollateralManagementCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/collateral-ticket-categories/collateral-management-categories/collateral-management-categories.component"
        );

      case "CollateralDashboardComponent":
        return import(
          "../service-desk/collateral-management/collateral-dashboard/collateral-dashboard.component"
        );

      case "CollateralArchivedSubcategoriesComponent":
        return import(
          "../service-desk/ticket-categories/collateral-ticket-categories/collateral-archived-subcategories/collateral-archived-subcategories.component"
        );

      case "CollateralServiceTicketEditComponent":
        return import(
          "../service-desk/collateral-management/collateral-service-ticket-edit/collateral-service-ticket-edit.component"
        );

      case "CollateralManagementReportComponent":
        return import(
          "../service-desk/service-desk-dashboard/report/collateral-management-report/collateral-management-report.component"
        );

      case "ItSupportArchiveCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/it-support-ticket-categories/it-support-archived-category-dashboard/it-support-archived-category-dashboard.component"
        );

      case "ItSupportApproverRequestComponent":
        return import(
          "../service-desk/it-support/it-support-ticket-edit/components/it-support-approver-request/it-support-approver-request.component"
        );

      case "ItSupportVendorDashboardComponent":
        return import(
          "../service-desk/vendor/vendor-dashboard/it-support-vendor-dashboard/it-support-vendor-dashboard.component"
        );

      case "ItSupportAddEditVendorComponent":
        return import(
          "../service-desk/vendor/add-edit-vendor/it-support-add-edit-vendor/it-support-add-edit-vendor.component"
        );

      case "ITSupportReportComponent":
        return import(
          "../service-desk/service-desk-dashboard/report/it-support-report/it-support-report.component"
        );

      case "ChangeControlPolicyDashboardComponent":
        return import(
          "../service-desk/ticket-categories/it-support-ticket-categories/change-control-policy/change-control-policy-dashboard/change-control-policy-dashboard.component"
        );

      case "ArchivedChangeControlPoliciesDashboardComponent":
        return import(
          "../service-desk/ticket-categories/it-support-ticket-categories/change-control-policy/archived-change-control-policies-dashboard/archived-change-control-policies-dashboard.component"
        );

      case "BranchAdminCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/branch-admin-ticket-categories/branch-admin-category-dashboard/branch-admin-category-dashboard.component"
        );

      case "MarketingCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/marketing-ticket-categories/marketing-category-dashboard/marketing-category-dashboard.component"
        );

      case "FacilitiesCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/facilities-ticket-categories/facilities-category-dashboard/facilities-category-dashboard.component"
        );

      case "BranchAdminArchivedCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/branch-admin-ticket-categories/branch-admin-archived-categories/branch-admin-archived-categories.component"
        );

      case "MarketingArchivedCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/marketing-ticket-categories/marketing-archived-categories/marketing-archived-categories.component"
        );

      case "FacilitiesArchivedCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/facilities-ticket-categories/facilities-archived-categories/facilities-archived-categories.component"
        );

      case "LoanAdminServiceTicketAddComponent":
        return import(
          "../service-desk/loan-admin/loan-admin-ticket-add/loan-admin-ticket-add.component"
        );

      case "LoanAdminDashboardComponent":
        return import(
          "../service-desk/loan-admin/loan-admin-dashboard/loan-admin-dashboard.component"
        );

      case "LoanAdminCategoriesComponent":
        return import(
          "../service-desk/ticket-categories/loan-admin-ticket-categories/tabs/loan-admin-category/loan-admin-category-dashboard/loan-admin-category-dashboard.component"
        );

      case "LoanAdminArchivedCategoryDashboardComponent":
        return import(
          "../service-desk/ticket-categories/loan-admin-ticket-categories/tabs/loan-admin-category/loan-admin-archived-category-dashboard/loan-admin-archived-category-dashboard.component"
        );

      case "LoanAdminManagementDashboardComponent":
        return import(
          "../service-desk/ticket-categories/loan-admin-ticket-categories/loan-admin-management-dashboard.component"
        );

      case "LoanAdminArchivedLoanTypeDashboardComponent":
        return import(
          "../service-desk/ticket-categories/loan-admin-ticket-categories/tabs/loan-admin-loan-type/loan-admin-archived-loan-type-dashboard/loan-admin-archived-loan-type-dashboard.component"
        );

      case "LoanAdminArchivedSubcategoryDashboardComponent":
        return import(
          "../service-desk/ticket-categories/loan-admin-ticket-categories/tabs/loan-admin-subcategory/loan-admin-archived-subcategory-dashboard/loan-admin-archived-subcategory-dashboard.component"
        );

      case "LoanAdminServiceTicketEditComponent":
        return import(
          "../service-desk/loan-admin/loan-admin-ticket-edit/loan-admin-ticket-edit.component"
        );

      case "LoanAdminReportComponent":
        return import(
          "../service-desk/service-desk-dashboard/report/loan-admin-report/loan-admin-report.component"
        );

      case "SlaReportComponent":
        return import(
          "../service-desk/service-desk-dashboard/report/sla-report/sla-report.component"
        );

      case "ToDoEventComponent":
        return import(
          "../admin/home/to-do-list/view-to-do-list/view-to-do-list.component"
        );

      case "ToDoListActionModelComponent":
        return import(
          "../admin/home/to-do-list/shared/to-do-list-action-model/to-do-list-action-model.component"
        );

      case "AddEditToDoListComponent":
        return import(
          "../admin/home/to-do-list/to-do-details/to-do-details.component"
        );

      case "ToDoAuditDetailsModelComponent":
        return import(
          "../admin/home/to-do-list/shared/to-do-audit-details-model/to-do-audit-details-model.component"
        );

      case "TravelRequestDashboardComponent":
        return import(
          "../travel-request/dashboard/travel-request-dashboard/travel-request-dashboard.component"
        );

      case "TravelRequestAddEditComponent":
        return import(
          "../travel-request/add-edit/travel-request-add-edit/travel-request-add-edit.component"
        );

      case "TravelRecordAuthComponent":
        return import(
          "../travel-request/add-edit/tabs/travel-record-auth/travel-record-auth.component"
        );

      case "TravelDetailsComponent":
        return import(
          "../travel-request/add-edit/tabs/travel-details/travel-details.component"
        );

      case "VehicleLienDashboardComponent":
        return import(
          "../vehicle-lien/components/vehicle-lien-dashboard/vehicle-lien-dashboard.component"
        );

      case "VehicleLienDetailsComponent":
        return import(
          "../vehicle-lien/components/vehicle-lien-details/vehicle-lien-details.component"
        );

      case "WorkLocationsViewComponent":
        return import(
          "../work-locations/components/work-locations-view/work-locations-view.component"
        );

      case "WorkflowComponent":
        return import("../workflow/components/workflow/workflow.component");

      case "WorkflowListComponent":
        return import(
          "../workflow/components/workflow-list/workflow-list.component"
        );

      case "JobComponent":
        return import("../workflow/components/job/job.component");

      case "JobListComponent":
        return import("../workflow/components/job-list/job-list.component");

      case "JobDetailComponent":
        return import("../workflow/components/job-detail/job-detail.component");

      case "TaskComponent":
        return import("../workflow/components/task/task.component");

      case "TaskListComponent":
        return import("../workflow/components/task-list/task-list.component");

      case "UserCreditListComponent":
        return import(
          "../workflow/components/user-credit-list/user-credit-list.component"
        );

      case "UserCreditComponent":
        return import(
          "../workflow/components/user-credit/user-credit.component"
        );
      default:
        return import("../admin/page-not-found/page-not-found.component");
    }
  }
}
